module.exports = __webpack_public_path__ + "static/assets/c8215bcfbb4dc9000bb0da3947cdb523.png";